'use client'

const items = [
  { q: 'AVA saved me ~6 hrs/wk just from meeting notes. I capture everything while walking between offices — the AI transcription is perfect and tasks create themselves.',
    save: '6 hours/week saved', n: 'Nora', r: 'Product Manager · TechFlow Inc.' },
  { q: 'The Calendar Hub integrating Google and Outlook has been a game changer. I can schedule meetings by voice while driving to client sites. No more app switching — everything syncs perfectly.',
    save: '12 hours/week saved', n: 'Marcus Thompson', r: 'Sales Director · SalesForce Partners' },
  { q: 'The long dictation feature is perfect for patient notes. I record entire consultations and AVA organizes them into structured notes with mind maps. It’s like having a medical assistant.',
    save: '15 hours/week saved', n: 'Dr. Emily Rodriguez', r: 'Family Physician · HealthFirst Medical' },
  { q: 'My grades jumped by giving me summaries I actually review. AVA turns hour-long lectures into 5-minute notes. The smart search finds anything in seconds.',
    save: '10 hours/week saved', n: 'Anish', r: 'CS Student · MIT' },
  { q: 'The Project Hub is brilliant for managing multiple clients. Each project has its own tasks, appointments, and notes. The AI morning brief gives me a perfect start to every day with priorities laid out.',
    save: '18 hours/week saved', n: 'Priya Sharma', r: 'Founder & CEO · InnovateLabs' },
  { q: 'WhatsApp integration is a lifesaver! Clients can check case status via WhatsApp, and I can add tasks while in court. The smart recurring reminders ensure I never miss a filing deadline.',
    save: '14 hours/week saved', n: 'David Martinez', r: 'Attorney · Martinez & Associates' },
  { q: 'The image and PDF smart search is amazing for my design work. I can find specific mockups instantly by just describing them. Cross-platform sync means I access everything from web, mobile, and Chrome extension.',
    save: '9 hours/week saved', n: 'Olivia Thompson', r: 'Freelance Designer · Self-Employed' },
  { q: 'I use the Chrome extension’s deep focus mode during content creation. The eye exercise reminders are thoughtful. Voice commands work even when I’m cooking — just say what needs to be done and it’s captured!',
    save: '11 hours/week saved', n: 'Ryan Patel', r: 'Marketing Manager · BrandWorks' },
]

const initials = (name) =>
  name.split(' ').map((s) => s[0]).slice(0, 2).join('')

export default function TestimonialsMarquee() {
  const track = [...items, ...items]
  return (
    <div className="testi-marquee">
      <div className="testi-row">
        {track.map((t, i) => (
          <article className="testi" key={i}>
            <p className="quote-text">&ldquo;{t.q}&rdquo;</p>
            <div className="savings">{t.save}</div>
            <div className="author-row">
              <div className="avatar">{initials(t.n)}</div>
              <div className="who">
                <div className="name">{t.n}</div>
                <div className="role">{t.r}</div>
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  )
}
